import * as angular from 'angular';

import { ComponentDefinition, ContextualField, Group, PropertyType } from '../../../models/index';
import { ReconciliationMeasureConfiguration } from '../ReconciliationMeasureConfiguration';

class ModernReconciliationMeasureContextualController implements angular.IComponentController {
    configuration: ReconciliationMeasureConfiguration;
    properties: ContextualField[];
    groups: Group[];

    readonly save: () => void;

    static $inject = ['$q'];

    constructor(private _$q: angular.IQService) {
    }

    $onInit() {
        this.properties = [
            {
                modelName: 'groupGuid',
                propertyType: PropertyType.Group,
                label: 'Groups',
                propertyName: 'groupGuidProperty',
                icon: 'fa-sitemap',
                required: true,
                extraData: {
                    groups: this.groups
                        ? this.groups.filter(g => g.reconciliationMatrix?.length)
                        : [],
                    placement: 'bottom-right'
                },
                messages: [{
                    key: 'required',
                    value: 'A group is required'
                }]
            }
        ];
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['groups'] && this.groups && this.properties?.length > 0) {
            this.properties[0].extraData.groups = this.groups.filter(g => g.reconciliationMatrix?.length);
        }
    }

    onSave(): angular.IPromise<void> {
        return this._$q.when(this.save());
    }
}

export const wtModernReconciliationMeasureContextual: ComponentDefinition = {
    componentId: 'wtModernReconciliationMeasureContextual',
    controller: ModernReconciliationMeasureContextualController,
    template: require('./modernReconciliationMeasureContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        cancel: '&?',
        configuration: '<',
        formController: '=',
        groups: '<',
        save: '&?'
    }
};
